export const classes = {
  skeleton: 'py-6',
};

export const styles = {
  skeleton: (delay: number, duration: number) => ({
    '&:after': {
      animationDelay: `${delay}s`,
      animationDuration: `${duration}s`,
    },
  }),
};
